import { render, staticRenderFns } from "./KompasVergelijker.vue?vue&type=template&id=520bc3b7&"
import script from "./KompasVergelijker.vue?vue&type=script&lang=js&"
export * from "./KompasVergelijker.vue?vue&type=script&lang=js&"
import style0 from "./KompasVergelijker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports